import React from 'react';
import { Box, Typography } from '@mui/material';
import { School } from '@mui/icons-material';
import PlanCard from './PlanCard';

/**
 * PlanShelf — horizontal scroll shelf of PlanCards.
 * Empty state: School icon + message.
 *
 * @param {object[]} plans
 * @param {(plan) => void} onShowInterest
 */
function PlanShelf({ plans, onShowInterest }) {
  if (plans.length === 0) {
    return (
      <Box
        sx={{
          p: 4,
          textAlign: 'center',
          borderRadius: '16px',
          border: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <School sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
        <Typography color="text.secondary">
          No programs published yet — tap &lsquo;Express General Interest&rsquo; to get personalised options.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        overflowX: 'auto',
        pb: 2,
        '&::-webkit-scrollbar': { height: 8 },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'rgba(0,0,0,0.05)',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,0.2)',
          borderRadius: '4px',
        },
      }}
    >
      {plans.map((plan, index) => (
        <PlanCard
          key={plan.id}
          plan={plan}
          featured={plans.length > 1 && index === 0}
          onShowInterest={onShowInterest}
        />
      ))}
    </Box>
  );
}

export default PlanShelf;
